//Newsletter
function comprueba(){
  	var boton = document.getElementById("Subscribe");
  	var input_mail = document.getElementById("Email");
  	var input_check = boton.querySelector("span");
  
	if(check.checked){
	 boton.disabled = false;
     input_check.classList.add("check-newsletter");
     input_mail.classList.add("border-newsletter"); 
     input_mail.focus();
	}
	else{
	 boton.disabled = true;
     input_check.classList.remove("check-newsletter");
      input_mail.classList.remove("border-newsletter");
	}
}
 
$(document).ready(function() {
 var check = document.getElementById('check');
   document.getElementById("Subscribe").disabled = true;
 if (!check) {
	 return;
 } else {
	 check.addEventListener("change", comprueba, false);
 }
});



//Filtros Categorias
$(function() {
      var currentTags = '{{ current_tags }}',
      filters = $('.advanced-filter'),
        activeTag,
        activeHandle;

      filters.each(function() {
        var el = $(this),
            group = el.data('group'),
            isActive = el.hasClass('active-filter');
      });

      filters.on('click', function(e) {
        var el = $(this),
            group = el.data('group'),
            url = el.find('a').attr('href');

        // Continue as normal if we're clicking on the active link
        if ( el.hasClass('active-filter') ) {
          return;
        }

        // Get active group link (unidentified if there isn't one)
        activeTag = $('.active-filter[data-group="'+ group +'"]');

        // If a tag from this group is already selected, remove it from the new tag's URL and continue
        if ( activeTag && activeTag.data('group') === group ) {
          e.preventDefault();
          activeHandle = activeTag.data('handle') + '+';

          // Create new URL without the currently active handle
          url = url.replace(activeHandle, '');

          window.location = url;
        }
      });
      
      
      //Cusom BigBuy
      var bbStyle = document.createElement('style');

        bbStyle.setAttribute('type', 'text/css');

        bbStyle.innerHTML = ".bb-closed {margin-bottom:0;overflow: hidden;}.trigger {margin-bottom:10px; margin-left: 25px; border: none;width: 100px; background-color: #e8e8e8; color: #000}.trigger:hover {background-color: #9c9c9c; color:#fff}.trigger-content {content: -}";

        document.head.appendChild(bbStyle);

        var categorias = $('.advanced-filters');

        var totalItemsToShow = 5;

        function getHeight (el) {
          var totalHeight = 0;
          var elMarginBottom = el.css('margin-bottom');
    
          el.each( function (i) {
            if(i < totalItemsToShow) {
              totalHeight = totalHeight + $(this).height() + parseFloat(elMarginBottom);
            }
          })
          return totalHeight;
        };

        categorias.each(function (index) {
          var $this = $(this);

          if ($this.children().length > totalItemsToShow) {
            var $parentEl = $this.parent();
            var itemsHeight = getHeight($this.children('.advanced-filter'));

            $this.addClass( "bb-closed" );

            $parentEl.append("<button class='trigger'>+</button>");

            $this.css('height', itemsHeight + 'px');
          }
        });

        $('#toggleFilters').click(function(e) {

          var filter = $('#collectionFilters');


          if(filter.css('display') == 'none') {
            setTimeout(function() {
              categorias.each(function (index) {
                var $this = $(this);

                if ($this.children().length > totalItemsToShow) {
                  var $parentEl = $this.parent();
                  var itemsHeight = getHeight($this.children('.advanced-filter'));

                  $this.addClass( "bb-closed" );

                  $this.css('height', itemsHeight + 'px');
                }
              })
            }, 100);	
          } else {
            $('.trigger').each(function () {
              $(this).text('+');
            })
          }

        });


        $('.trigger').click(function(e) {
          var iParent = $(this).parent().find('.advanced-filters');
          var iChield = iParent.children('.advanced-filter');
          var iButton = $(this).parent().find('.trigger');
          var iHeight = getHeight(iChield);

          if ( iParent.height() == iHeight) {
            iParent.css('height', 'auto');
            iButton.text('-');
          } else {
            iParent.css('height', iHeight + 'px');
            iButton.text('+');
          }
        });
      
       //ordenación Jquery

        numerically_ignore_letters = function(a,b){
        var non_digits = '^(\d)*';
        var a_val = parseInt( $('a', a).text().replace( non_digits, '' ), 10 );
        var b_val = parseInt( $('a', b).text().replace( non_digits, '' ), 10 );

        return  a_val - b_val;
      }
        
        elementos = $('ul.advanced-filters');
        elementos.each(function(){
          // Ordenar numéricamente los filtros
          $(this).children('li').sort( numerically_ignore_letters ).prependTo($(this));
        });
    });

    
    //scroll automático categorias
    $(window).on('load', function() {
      var container = $("ul.tmenu_submenu.tmenu_submenu_type_automatic.tmenu_submenu--desktop");
      var windowHeight = $(window).height();
      container.each(function(index) {
      var position = $(this).offset().top;
      var positionItem = windowHeight - position;
      $(this).css("max-height", positionItem);
  });
});